var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsuppWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.21 94.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.11,22.15c-13.78,0-24.96,11.17-24.96,24.96.03,4.77,1.39,9.43,3.93,13.46l-.3,2.27-.61,4.54-.45,3.48,3.63-.61,4.24-.76,2.57-.45c3.66,2.01,7.77,3.05,11.95,3.03,13.78,0,24.96-11.17,24.96-24.96s-11.17-24.96-24.96-24.96Zm13.61,36l-1.36,1.66c-1.97,2.42-3.63,2.57-6.2,1.97-9.69-2.45-17.38-9.8-20.27-19.36-1.08-3.46.44-7.2,3.63-8.92,1.66-1.06,2.72-.3,3.33,1.36l1.51,3.93s1.06,2.12-1.66,4.24q-.45.3-.3,1.06c.6,1.82,3.03,7.26,10.74,11.5.76.45.91.45,1.66-.15.61-.61,1.36-1.36,1.97-1.97,1.36-1.21,2.12-1.66,3.33-.76.91.6,1.82,1.36,2.72,1.97.91.76,2.42,1.66.91,3.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.11,0C21.09,0,0,21.09,0,47.11s21.09,47.11,47.11,47.11,47.11-21.09,47.11-47.11S73.12,0,47.11,0Zm.02,76.91h-.02c-4.34.05-8.63-.88-12.56-2.72l-15.88,2.72,2.12-15.73-.15-.3c-7.57-14.66-1.82-32.67,12.84-40.24,4.22-2.18,8.89-3.32,13.64-3.33,16.46,0,29.81,13.33,29.81,29.79,0,16.46-13.33,29.81-29.79,29.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsuppWhite);
export default __webpack_public_path__ + "static/media/whatsupp-white.837eeb6ab604b91ee468d8eda8a6f727.svg";
export { ForwardRef as ReactComponent };